export default __webpack_public_path__ + "static/media/Border Kingdom Cap.a786a2f3.jpg";